import { Button } from 'antd';
import React from 'react';

const DashboardButton = ({
  title,
  icon = '' as any,
  onClick,
  size = 'medium',
  className = '',
  isLoading = false,
}) => {
  return (
    <>
      <Button
        className={`ant-btn-primary ant-btn rounded ${className}`}
        icon={icon}
        onClick={onClick}
        size={size as any}
        loading={isLoading}
      >
        {title}
      </Button>
    </>
  );
};

export default DashboardButton;
